'use client';
import { useEffect } from 'react';

// Registers /sw.js and asks the browser to check it for a new version at once, so a fixed worker
// replaces an old one on the next visit (the previous code waited for a "load" event that had
// often already happened, so the worker could fail to register or update).
export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => registration.update())
      .catch((err) => console.warn('[SW] Registration failed:', err));
  }, []);

  return null;
}
